class ComponentRegistry {
    constructor() {
        this.components = new Map();
        this.instances = new Map(); // <= сохраняем созданные Vue-приложения
        this.autoRegister();
    }

    autoRegister() {
        const componentMap = {
            'Header': 'HeaderComponent',
            'Modals': 'ModalsComponent',
            'CatalogServices': 'CatalogServicesComponent',
            'SpecialistsServices': 'SpecialistsServicesComponent',
            'SpecialistsChildServices': 'SpecialistsChildServicesComponent',
            'SpecialistsPage': 'SpecialistsPageComponent',
            'Faq': 'FaqComponent',
            'Reviews': 'ReviewsComponent',
            'ServiceGroups': 'ServiceGroupsComponent',
            'ServiceGroupsChildBlock': 'ServiceGroupsChildBlockComponent',
            'ServiceGroupsBlock': 'ServiceGroupsBlockComponent',
            'DepartmentPage': 'DepartmentComponent',
            'ServicesPage': 'ServicesPageComponent',
            'recordForm': 'RecordPageComponent',
            'ArticlesPreview': 'ArticlesPreviewComponent',
            'Articles': 'ArticlesComponent',
            'Contract': 'ContractComponent',
            'Program': 'ProgramComponent',
            'Programs': 'ProgramsComponent',
            'FaqChild': 'FaqChildComponent',
            'Questions': 'QuestionsComponent',
            'ServicesTabs': 'ServicesTabsComponent',
        };

        for (const [elementId, componentName] of Object.entries(componentMap)) {
            const component = window[componentName];

            if (!component) {
                continue;
            }

            if (typeof component !== "object" || (!component.data && !component.methods)) {
                continue;
            }

            this.register(elementId, component);
        }
    }

    register(elementId, component) {
        this.components.set(elementId, component);
    }

    get(elementId) {
        return this.components.get(elementId);
    }

    getAll() {
        return [...this.components.entries()].map(([id, component]) => ({ id, component }));
    }

    mountAll() {
        const summary = {
            mounted: [],
            skippedAlreadyMounted: [],
            skippedMissingElement: [],
            failed: []
        };

        for (const { id, component } of this.getAll()) {
            const el = document.getElementById(id);

            if (!el) {
                summary.skippedMissingElement.push(id);
                continue;
            }

            // Prevent double mount
            if (this.instances.has(id)) {
                summary.skippedAlreadyMounted.push(id);
                continue;
            }

            try {
                const app = Vue.createApp(component);
                app.mount(el);

                this.instances.set(id, app); // save instance

                summary.mounted.push(id);
            } catch (err) {
                summary.failed.push(id);
            }
        }

        return summary;
    }

    unmount(id) {
        const instance = this.instances.get(id);

        if (!instance) {
            return false;
        }

        instance.unmount();
        this.instances.delete(id);

        return true;
    }

    unmountAll() {
        for (const id of this.instances.keys()) {
            this.unmount(id);
        }
    }
}

window.ComponentRegistry = ComponentRegistry;